/**
 * URL base de la API con prefijo de versión (p. ej. https://api.zyrisx.com/v1), sin barra final.
 *
 * Orden: REACT_APP_API_BASE_URL, REACT_APP_BACKEND_URL (alias), luego VITE_* vía craco.
 * En producción, si el build se hizo sin variable (cadena vacía en el bundle) y el SPA
 * se sirve en app.zyrisx.com, se usa https://api.zyrisx.com/v1 para no publicar POST al host del front.
 */
const DEFAULT_WHEN_HOST_APP = "https://api.zyrisx.com/v1";

export function getApiBaseUrl() {
  let raw = "";
  if (typeof process !== "undefined" && process.env) {
    raw =
      process.env.REACT_APP_API_BASE_URL ||
      process.env.REACT_APP_BACKEND_URL ||
      process.env.REACT_APP_VITE_API_BASE_URL ||
      process.env.VITE_API_BASE_URL ||
      "";
  }
  const trimmed = String(raw).trim().replace(/\/$/, "");
  if (trimmed) return trimmed;

  if (typeof window !== "undefined" && window.location.hostname === "app.zyrisx.com") {
    return DEFAULT_WHEN_HOST_APP;
  }

  return "";
}
